module.exports = __webpack_public_path__ + "img/india_headshot.d464c95b.jpg";